import { Typography } from "@mui/material"
import type { BiomeshPlatformResponse } from "@phc/common/gen/threatAnalyticsGen"
import {
  getListPlatformsBiomeshPlatformListGetQueryKey,
  useDeletePlatformBiomeshPlatformPlatformIdDelete,
} from "@phc/common/gen/threatAnalyticsGen"
import { useQueryClient } from "@tanstack/react-query"
import { enqueueSnackbar } from "notistack"
import type { FC } from "react"
import { useCallback } from "react"
import { Modal } from "../Shared/Modal"
import { extractApiError } from "./copUtils"

interface DeleteNodeDialogProps {
  open: boolean
  onClose: () => void
  node: BiomeshPlatformResponse
}

export const DeleteNodeDialog: FC<DeleteNodeDialogProps> = ({
  open,
  onClose,
  node,
}) => {
  const queryClient = useQueryClient()
  const { mutateAsync: deleteNode, isPending } =
    useDeletePlatformBiomeshPlatformPlatformIdDelete()

  const handleConfirm = useCallback(async () => {
    try {
      await deleteNode({ platformId: node.platform_id })
      await queryClient.invalidateQueries({
        queryKey: getListPlatformsBiomeshPlatformListGetQueryKey(),
      })
      enqueueSnackbar("Node deleted", { variant: "success" })
      onClose()
    } catch (err) {
      enqueueSnackbar(extractApiError(err, "Failed to delete node"), {
        variant: "error",
      })
    }
  }, [deleteNode, node.platform_id, queryClient, onClose])

  return (
    <Modal
      open={open}
      onClose={onClose}
      onConfirm={() => void handleConfirm()}
      title="Delete Node"
      confirmLabel="Delete"
      disableBtns={isPending}
    >
      <Typography sx={{ mt: 1 }}>
        Are you sure you want to delete <strong>{node.name}</strong>?
      </Typography>
    </Modal>
  )
}
